import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faArrowLeft, faArrowRight } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { formatSlotTimestamp } from '@utils/helpers';

type TimeSlotNavigatorProps = {
  selectorBounds: { min: number; max: number };
  timestamp: number;
  selectedSlot: number | null;
  totalSlots: number;
  handlePrevClick: () => void;
  handleNextClick: () => void;
  disableArrows?: boolean;
  className?: string;
  loading?: boolean;
};

export function TimeSlotNavigator({
  selectorBounds,
  timestamp,
  selectedSlot,
  handlePrevClick,
  handleNextClick,
  disableArrows,
  className,
  loading,
}: TimeSlotNavigatorProps) {
  const prevDisabled = selectedSlot === null || selectedSlot <= selectorBounds.min || disableArrows;
  const nextDisabled = selectedSlot === null || selectedSlot >= selectorBounds.max || disableArrows;

  return (
    <div className={clsx('mb-4 flex items-center justify-between', className)}>
      <button
        className="font-normal text-base900 disabled:text-base400"
        onClick={handlePrevClick}
        disabled={prevDisabled}
      >
        <FontAwesomeIcon icon={faArrowLeft} />
      </button>
      <span
        className={clsx(
          'mx-4 w-[50px] select-none text-center text-title-m font-medium text-base800',
          loading && 'animate-pulse',
        )}
      >
        {!loading ? formatSlotTimestamp(timestamp) : ''}
      </span>
      <button
        className="font-normal text-base900 disabled:text-base400"
        onClick={handleNextClick}
        disabled={nextDisabled}
      >
        <FontAwesomeIcon icon={faArrowRight} />
      </button>
    </div>
  );
}
